<template>
  <div class="dish-card">
    <div class="dish-card-body">
      <DishCard :dish="dish" :cache_nonce="cache_nonce"/>
    </div>

    <DangerConfirmModal
      @cancel="deleting = false"
      @confirm="onDelete"
      v-if="deleting"
      >{{ $t("dish_tab.confirm_delete") }}</DangerConfirmModal
    >

    <TransferDishModal
      @close="transfer_modal = false"
      @transfered="onDishTransfered"
      v-if="transfer_modal"
    />
  </div>
</template>

<script>
import DishCard from "@/components/menu/DishCard.vue";
import DishCardEditor from "@/components/menu/DishCardEditor.vue";
import BlackButton from "../BlackButton.vue";

import TransferDishModal from "@/components/menu/TransferDishModal.vue";

export default {
  data() {
    return {
      editing: false,
      deleting: false,
      transfer_modal: false,
      menu_valid: true,
      cache_nonce: 1
    };
  },
  props: {
    category: Object,
  },
  methods: {
    updateImageNonces() {
      this.cache_nonce = Date.now();
    },
    showEditUI() {
      this.editing = true;
      this.$emit("startEdit");
    },
    showDeleteUI() {
      this.deleting = true;
    },
    onEditFinish() {
      if (!this.editing) {
        return;
      }

      if (!this.validateDish()) {
        this.menu_valid = false;
        this.$emit("validation", this.menu_valid);
        this.$store.dispatch("showError", "menu_invalid");
        return;
      }

      this.menu_valid = true;
      this.$emit("validation", this.menu_valid);

      this.editing = false;
      this.$store.dispatch("menu/save");

      this.$emit("finishEdit");
    },
    toggleExclusive() {
      this.$store.commit("menu/toggleExclusive", this.dish);
      this.$store.dispatch("menu/updateProduct");
    },
    onDelete() {
      this.deleting = false;

      const auditlog_entry = {
        menu_id: this.$store.state.menu.current._id,
        menu_title: this.$store.state.menu.current.title,
        product_id: this.dish._id,
        name: this.dish.name,
        category: this.dish.category,
      };

      // this.$store.commit("menu/removeProduct", this.dish);
      // this.$store.commit("menu/chooseProduct", null);
      // this.$store.dispatch("menu/save");
      this.$store.dispatch("menu/removeProduct").then(() => {
        this.$store.dispatch("auditlog/write", {
          type: "remove_menu_product",
          payload: auditlog_entry,
        });

        if (this.category) {
          const other_products = this.$store.getters[
            "menu/productsForCategory"
          ](this.category);

          if (other_products.length) {
            this.$store.commit("menu/chooseProduct", other_products[0]);
          } else {
            this.$store.commit("menu/chooseProduct", null);
          }
        } else {
          this.$store.commit("menu/chooseProduct", null);
        }
      });

      // this.$emit('finishEdit');
    },
    validateDish() {
      const isNullOrUndefined = (arg) => arg === undefined || arg === null;

      const invalid_price_group = this.dish.price_groups.find((group) => {
        return !!group.items.find((item) => isNullOrUndefined(item.price));
      });

      return !invalid_price_group;
    },
    duplicateDish() {
      this.$store.dispatch("menu/duplicateProduct", {
        suffix: this.$t("menu_settings.duplicate_suffix"),
      });
    },
    onDishTransfered() {},
    chooseNearestProduct(category_name) {
      const other_products = this.$store.getters["menu/productsForCategory"]({
        name: category_name,
      });

      if (other_products.length) {
        this.$store.commit("menu/chooseProduct", other_products[0]);
      } else {
        this.$store.commit("menu/chooseProduct", null);
      }
    },
    onDishTransfered(to_another_menu) {
      this.chooseNearestProduct(this.category.name);
    },
  },
  mounted() {
    if (!this.editing) {
      this.$emit("finishEdit");
    }
  },
  computed: {
    dish() {
      return this.$store.state.menu.product;
    },
    isExampleMenu() {
      return this.$store.state.menu.current.is_example;
    },
  },
  // props: {
  //     dish: Object
  // },
  components: {
    DishCard,
    DishCardEditor,
    TransferDishModal,
    BlackButton,
  },
};
</script>

<style scoped>
.dish-card {
  width: 100%;
  display: block;
}

.dish-card-title {
  font-weight: 500;
  font-size: 3vh;
  margin-bottom: 0;

  color: #a4a3a1;
}

.dish-card-body {
  border-radius: 1vh;
}

.dish-card-scroll {
  overflow-y: auto;
  height: 47.3vh;
  background: #ededed;
  box-shadow: 0px 0.266vw 0.266vw rgba(0, 0, 0, 0.25);
  border-radius: 1vh;
  margin-top: 1.7vh;
  padding-bottom: 1vw;
}

.dish-tab-actions {
  display: flex;
  justify-content: space-evenly;
  margin-top: 3.3vh;
  align-items: center;
}

.exclusive-toggle {
  display: flex;
  align-items: flex-end;
  cursor: pointer;
}

.star {
  display: block;
  height: 3.4vh !important;
  width: 3.4vh !important;
}

.btn-actions {
  float: right;
  display: flex;
}

.lower-btn-actions {
  float: right;
  display: flex;
  margin-top: 2.2vh;
}

.duplicate {
  background: #cbd9e6 url(../../assets/duplicate.svg) no-repeat center left;
  background-size: 1.7vh;
  color: #1d1d1d !important;
  background-position-x: 1vh;
  padding-left: 4.5vh !important;
  border-radius: 0.5vh;
}
.delete {
  background: #e2223b url(../../assets/delete.png) no-repeat center left;
  background-size: 1.7vh;
  background-position-x: 1vh;
  padding-left: 4.5vh !important;
  border-radius: 0.5vh;
}
.transfer {
  background: #ffd2a8 url(../../assets/move_dish.svg) no-repeat center left;
  background-size: 1.7vh;
  color: #1d1d1d !important;
  background-position-x: 1.5vh;
  padding-left: 4.5vh !important;
  border-radius: 0.5vh;
}

.lower-btn-actions button {
  border: 0;
  font-weight: 400;
  font-size: 1.6vh;
  color: #fff;
  padding: 0.5vh 1vh;
  outline: none;
  cursor: pointer;
}

.btn-actions button {
  border: 0;
  font-weight: 400;
  font-size: 1.6vh;
  color: #fff;
  padding: 0.5vh 1vh;
  margin: 2.2vh 0 0 1vh;
  outline: none;

  cursor: pointer;
}
</style>
